/**
 * TanStack Query hooks for `leaderboard`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	leaderboardQueryKeys,
	type CreateLeaderboardBody,
	type ListLeaderboardResponse,
	type LeaderboardRow,
} from "./api";

export function useLeaderboardList(): UseQueryResult<ListLeaderboardResponse, Error> {
	return useQuery({
		queryKey: leaderboardQueryKeys.list(),
		queryFn: list,
	});
}

export function useLeaderboardCreate(): UseMutationResult<LeaderboardRow, Error, CreateLeaderboardBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: leaderboardQueryKeys.all });
		},
	});
}

export function useLeaderboardDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: leaderboardQueryKeys.all });
		},
	});
}
